import { useRecoilState } from 'recoil';
import { quizTranslationState } from "../states/quizState";
import { useEcoClient, useEcoMutation } from 'hooks';
import { useEffect } from 'react';

export const useQuizLoadTranslation = (lg?: string) => {
    const [translation, setTranslation] =  useRecoilState(quizTranslationState) ;
    const ecoClient = useEcoClient();
    const loadTranslation = useEcoMutation(async (params: translationParams ) => {
        return ecoClient.get({
            path: `quiz.getTranslation`,
            params: {...params}
        })
    })
    useEffect(() => {
        if(translation.length == 0) {
            loadTranslation.mutate({language: lg || 'fr', bundle: process.env.REACT_APP_ECO_APP_NAME || 'medical-device'}, {
                onSuccess: (res: any) => {
                    setTranslation(res.data)
                },
                onError: (e) => {
                    console.log(e)
                }
            })
        }
        
    }, [translation])
    return (translation.length == 0 ? false : true)
}

type translationParams = {
    language: string
    bundle: string
}